<div class="row header">
    <div class="col text-center">
        <strong>{{ titulo }}</strong>
    </div>
    <div class="col text-center">
        <strong>{{ mensaje | uppercase }}</strong>
    </div>
</div>